import { createFileRoute } from "@tanstack/react-router";

import { StartOnboarding } from "./-components/StartOnboarding";

export const Route = createFileRoute("/_authenticated/settings/onboarding")({
  component: StartOnboarding,
});
